@import "@/scss/use-bootstrap-mixins";

.buttons {
  display: flex !important;
  flex-direction: column;
  width: 100%;
  gap: 14px;
  overflow: hidden;

  // button {
  //     width: 100%;
  //     font-size: 16px;
  //     height: 48px;
  //     font-weight: 600;
  //     border-radius: 14px;

  //     &:hover {
  //         cursor: pointer;
  //     }

  //     label:hover {
  //         cursor: pointer;
  //     }

  //     &.primary_buttons {
  //         &:first-child,
  //         &:nth-child(2) {
  //             background-color: transparent;
  //             border: 2px solid $textColorOnPrimary;
  //             color: $textColorOnPrimary !important;
  //         }

  //         &:last-child {
  //             background-color: #fff;
  //             border: 2px solid #fff;
  //         }
  //     }

  //     &.upsell_buttons {
  //         &:first-child,
  //         &:nth-child(2) {
  //             background-color: transparent;
  //             border: 2px solid $primaryOnBackground;
  //             color: $primaryOnBackground !important;
  //         }

  //         &:last-child {
  //             background-color: var(--rs-theme);
  //             border: 2px solid var(--rs-theme);
  //             color: $textColorOnPrimary !important;
  //         }
  //     }
  // }
}
